import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Document, Page, Text, View, StyleSheet, pdf } from '@react-pdf/renderer';
const pdfStyles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 10,
        padding: 48,
        color: '#1d1d1f',
    },
    header: {
        marginBottom: 24,
        borderBottomWidth: 2,
        borderBottomColor: '#0071e3',
        borderBottomStyle: 'solid',
        paddingBottom: 16,
    },
    headerTitle: {
        fontSize: 28,
        fontFamily: 'Helvetica-Bold',
        color: '#0071e3',
        letterSpacing: 2,
    },
    headerSubtitle: {
        fontSize: 14,
        color: '#86868b',
        marginTop: 4,
        fontFamily: 'Helvetica',
    },
    headerDate: {
        fontSize: 10,
        color: '#86868b',
        marginTop: 4,
    },
    twoCol: {
        flexDirection: 'row',
        gap: 24,
        marginBottom: 20,
    },
    colHalf: {
        flex: 1,
    },
    sectionTitle: {
        fontSize: 11,
        fontFamily: 'Helvetica-Bold',
        color: '#0071e3',
        marginBottom: 6,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
    },
    sectionBox: {
        backgroundColor: '#f5f5f7',
        padding: 10,
        borderRadius: 4,
    },
    fieldLabel: {
        fontSize: 8,
        color: '#86868b',
        marginBottom: 1,
        textTransform: 'uppercase',
    },
    fieldValue: {
        fontSize: 10,
        color: '#1d1d1f',
        marginBottom: 5,
    },
    descriptionBox: {
        marginBottom: 20,
    },
    descText: {
        fontSize: 10,
        color: '#3c3c43',
        lineHeight: 1.5,
        padding: 10,
        backgroundColor: '#f5f5f7',
        borderRadius: 4,
    },
    lineItemsSection: {
        marginBottom: 20,
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#1d1d1f',
        padding: '6 10',
        borderRadius: 2,
        marginBottom: 2,
    },
    tableHeaderText: {
        color: '#ffffff',
        fontSize: 9,
        fontFamily: 'Helvetica-Bold',
    },
    tableRow: {
        flexDirection: 'row',
        padding: '5 10',
        borderBottomWidth: 1,
        borderBottomColor: '#e5e5e7',
        borderBottomStyle: 'solid',
    },
    tableRowAlt: {
        backgroundColor: '#f9f9f9',
    },
    colDesc: { flex: 4 },
    colQty: { flex: 1, textAlign: 'right' },
    colUnit: { flex: 1, textAlign: 'center' },
    colPrice: { flex: 1.5, textAlign: 'right' },
    colTotal: { flex: 1.5, textAlign: 'right' },
    cellText: {
        fontSize: 9,
        color: '#1d1d1f',
    },
    typeLabel: {
        fontSize: 11,
        fontFamily: 'Helvetica-Bold',
        color: '#3c3c43',
        marginBottom: 6,
        marginTop: 12,
    },
    totalsSection: {
        marginTop: 16,
        alignItems: 'flex-end',
    },
    totalsBox: {
        width: 200,
    },
    totalRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 4,
        borderBottomWidth: 1,
        borderBottomColor: '#e5e5e7',
        borderBottomStyle: 'solid',
    },
    totalLabelText: {
        fontSize: 10,
        color: '#86868b',
    },
    totalValueText: {
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
        color: '#1d1d1f',
    },
    grandTotalRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 6,
        borderTopWidth: 2,
        borderTopColor: '#0071e3',
        borderTopStyle: 'solid',
        marginTop: 4,
    },
    grandTotalLabel: {
        fontSize: 12,
        fontFamily: 'Helvetica-Bold',
        color: '#1d1d1f',
    },
    grandTotalValue: {
        fontSize: 12,
        fontFamily: 'Helvetica-Bold',
        color: '#0071e3',
    },
    footer: {
        position: 'absolute',
        bottom: 32,
        left: 48,
        right: 48,
        borderTopWidth: 1,
        borderTopColor: '#e5e5e7',
        borderTopStyle: 'solid',
        paddingTop: 8,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    footerText: {
        fontSize: 8,
        color: '#86868b',
    },
});
export const EstimatePDF = ({ estimate }) => {
    const laborItems = estimate.lineItems.filter((li) => li.type === 'labor');
    const materialItems = estimate.lineItems.filter((li) => li.type === 'material');
    const renderLineItems = (items) => items.map((li, idx) => (_jsxs(View, { style: [pdfStyles.tableRow, idx % 2 === 1 ? pdfStyles.tableRowAlt : {}], children: [_jsx(View, { style: pdfStyles.colDesc, children: _jsx(Text, { style: pdfStyles.cellText, children: li.description || '—' }) }), _jsx(View, { style: pdfStyles.colQty, children: _jsx(Text, { style: pdfStyles.cellText, children: li.qty }) }), _jsx(View, { style: pdfStyles.colUnit, children: _jsx(Text, { style: pdfStyles.cellText, children: li.unit }) }), _jsx(View, { style: pdfStyles.colPrice, children: _jsxs(Text, { style: pdfStyles.cellText, children: ["$", li.unitPrice.toFixed(2)] }) }), _jsx(View, { style: pdfStyles.colTotal, children: _jsxs(Text, { style: pdfStyles.cellText, children: ["$", (li.qty * li.unitPrice).toFixed(2)] }) })] }, li.lineItemId)));
    const tableHeaderRow = (_jsxs(View, { style: pdfStyles.tableHeader, children: [_jsx(View, { style: pdfStyles.colDesc, children: _jsx(Text, { style: pdfStyles.tableHeaderText, children: "Description" }) }), _jsx(View, { style: pdfStyles.colQty, children: _jsx(Text, { style: pdfStyles.tableHeaderText, children: "Qty" }) }), _jsx(View, { style: pdfStyles.colUnit, children: _jsx(Text, { style: pdfStyles.tableHeaderText, children: "Unit" }) }), _jsx(View, { style: pdfStyles.colPrice, children: _jsx(Text, { style: pdfStyles.tableHeaderText, children: "Unit Price" }) }), _jsx(View, { style: pdfStyles.colTotal, children: _jsx(Text, { style: pdfStyles.tableHeaderText, children: "Total" }) })] }));
    return (_jsx(Document, { children: _jsxs(Page, { size: "A4", style: pdfStyles.page, children: [_jsxs(View, { style: pdfStyles.header, children: [_jsx(Text, { style: pdfStyles.headerTitle, children: "GLAZIER" }), _jsx(Text, { style: pdfStyles.headerSubtitle, children: "ESTIMATE" }), _jsxs(Text, { style: pdfStyles.headerDate, children: ["Date: ", new Date(estimate.createdAt).toLocaleDateString(), " | ID:", ' ', estimate.id.slice(0, 16)] })] }), _jsxs(View, { style: pdfStyles.twoCol, children: [_jsxs(View, { style: pdfStyles.colHalf, children: [_jsx(Text, { style: pdfStyles.sectionTitle, children: "Customer" }), _jsxs(View, { style: pdfStyles.sectionBox, children: [_jsx(Text, { style: pdfStyles.fieldLabel, children: "Name" }), _jsx(Text, { style: pdfStyles.fieldValue, children: estimate.customerName }), estimate.customerId && (_jsxs(_Fragment, { children: [_jsx(Text, { style: pdfStyles.fieldLabel, children: "Customer ID" }), _jsx(Text, { style: pdfStyles.fieldValue, children: estimate.customerId })] }))] })] }), _jsxs(View, { style: pdfStyles.colHalf, children: [_jsx(Text, { style: pdfStyles.sectionTitle, children: "Site Address" }), _jsxs(View, { style: pdfStyles.sectionBox, children: [_jsx(Text, { style: pdfStyles.fieldValue, children: estimate.siteAddress.street }), _jsxs(Text, { style: pdfStyles.fieldValue, children: [estimate.siteAddress.city, ", ", estimate.siteAddress.state, ' ', estimate.siteAddress.zip] })] })] })] }), _jsxs(View, { style: pdfStyles.descriptionBox, children: [_jsx(Text, { style: pdfStyles.sectionTitle, children: "Project Description" }), _jsx(Text, { style: pdfStyles.descText, children: estimate.projectDescription })] }), estimate.requirements ? (_jsxs(View, { style: pdfStyles.descriptionBox, children: [_jsx(Text, { style: pdfStyles.sectionTitle, children: "Requirements" }), _jsx(Text, { style: pdfStyles.descText, children: estimate.requirements })] })) : null, _jsxs(View, { style: pdfStyles.lineItemsSection, children: [_jsx(Text, { style: pdfStyles.sectionTitle, children: "Line Items" }), materialItems.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Text, { style: pdfStyles.typeLabel, children: "Materials" }), tableHeaderRow, renderLineItems(materialItems)] })), laborItems.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Text, { style: pdfStyles.typeLabel, children: "Labor" }), tableHeaderRow, renderLineItems(laborItems)] })), estimate.lineItems.length === 0 && (_jsx(Text, { style: { fontSize: 10, color: '#86868b', fontStyle: 'italic' }, children: "No line items." }))] }), _jsx(View, { style: pdfStyles.totalsSection, children: _jsxs(View, { style: pdfStyles.totalsBox, children: [_jsxs(View, { style: pdfStyles.totalRow, children: [_jsx(Text, { style: pdfStyles.totalLabelText, children: "Labor Total" }), _jsxs(Text, { style: pdfStyles.totalValueText, children: ["$", estimate.laborTotal.toFixed(2)] })] }), _jsxs(View, { style: pdfStyles.totalRow, children: [_jsx(Text, { style: pdfStyles.totalLabelText, children: "Material Total" }), _jsxs(Text, { style: pdfStyles.totalValueText, children: ["$", estimate.materialTotal.toFixed(2)] })] }), _jsxs(View, { style: pdfStyles.grandTotalRow, children: [_jsx(Text, { style: pdfStyles.grandTotalLabel, children: "Grand Total" }), _jsxs(Text, { style: pdfStyles.grandTotalValue, children: ["$", estimate.totalAmount.toFixed(2)] })] })] }) }), estimate.notes ? (_jsxs(View, { style: { marginTop: 16 }, children: [_jsx(Text, { style: pdfStyles.sectionTitle, children: "Notes" }), _jsx(Text, { style: pdfStyles.descText, children: estimate.notes })] })) : null, _jsxs(View, { style: pdfStyles.footer, fixed: true, children: [_jsxs(Text, { style: pdfStyles.footerText, children: ["GLAZIER \u2014 Estimate #", estimate.id.slice(0, 8)] }), _jsxs(Text, { style: pdfStyles.footerText, children: ["Generated ", new Date().toLocaleDateString()] })] })] }) }));
};
export const DownloadPDFButton = ({ estimate }) => {
    const [loading, setLoading] = useState(false);
    const handleDownload = async () => {
        setLoading(true);
        try {
            const blob = await pdf(_jsx(EstimatePDF, { estimate: estimate })).toBlob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `estimate-${estimate.id}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx("button", { onClick: handleDownload, disabled: loading, style: {
            padding: '12px 28px',
            backgroundColor: loading ? '#86868b' : '#0071e3',
            color: '#fff',
            border: 'none',
            borderRadius: '980px',
            fontSize: '15px',
            fontWeight: '600',
            cursor: loading ? 'not-allowed' : 'pointer',
            minHeight: '44px',
        }, children: loading ? 'Generating PDF…' : '⬇ Download PDF' }));
};
// useState must be imported for DownloadPDFButton
import { useState } from 'react';
//# sourceMappingURL=EstimatePDF.js.map